<template>
    <!--  BEGIN SIDEBAR  -->
    <div class="sidebar-wrapper sidebar-theme">
        <nav ref="menu" id="sidebar">
            <div class="shadow-bottom"></div>
            <perfect-scrollbar class="list-unstyled menu-categories" tag="ul" :options="{ wheelSpeed: 0.5, swipeEasing: !0, minScrollbarLength: 40, maxScrollbarLength: 300, suppressScrollX: true }">
                <br>
                <li class="menu">
                    <router-link to="/leaderboard" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <DashboardSVG />
                            <span>{{ t('leaderboard') }}</span>
                        </div>
                    </router-link>
                </li>

                <li class="menu">
                    <router-link to="/activity-log" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <ActivityLogSVG />
                            <span>{{ t('activity_log') }}</span>
                        </div>
                    </router-link>
                </li>

                <li class="menu hide-menu">
                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#dashboard" aria-controls="dashboard" aria-expanded="false">
                        <div class="">
                            <DashboardSVG />
                            <span>{{ t('dashboard') }}</span>
                        </div>
                        <div>
                            <ChevronRightSVG />
                        </div>
                    </a>

                    <ul id="dashboard" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                        <li>
                            <router-link to="/home" @click="toggleMobileMenu">
                                {{ t('sales') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/index2" @click="toggleMobileMenu">
                                {{ t('analytics') }}
                            </router-link>
                        </li>
                    </ul>
                </li>
                <li class="menu hide-menu">
                    <router-link to="/events" class="dropdown-toggle " @click="toggleMobileMenu">
                        <div class="">
                            <EventSVG />
                            <span>{{ t('events') }}</span>
                        </div>
                    </router-link>
                </li>

                <li class="menu">
                    <router-link to="/catalog" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <CatalogSVG />
                            <span>{{ t('catalog') }}</span>
                        </div>
                    </router-link>
                </li>

                <li class="menu employees-menu">
                    <router-link to="/users" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <UsersSVG />
                            <span>{{ t('employees') }}</span>
                        </div>
                    </router-link>
                </li>

                <li class="menu">
                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#points" aria-controls="points" aria-expanded="false">
                        <div class="">
                            <PointsSVG />
                            <span>{{ t('points') }}</span>
                        </div>
                        <div>
                            <ChevronRightSVG />
                        </div>
                    </a>

                    <ul id="points" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                        <li>
                            <router-link to="/points/add" @click="toggleMobileMenu">
                                {{ t('give_reward') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/points/list" @click="toggleMobileMenu">
                                {{ t('show_points') }}
                            </router-link>
                        </li>
                    </ul>
                </li>

                <li class="menu">
                    <router-link to="/points/received-redeem-requests" class="dropdown-toggle" @click="toggleMobileMenu">
                        <div class="">
                            <RedeemSVG />
                            <span>{{ t('redeem_requests') }}</span>
                        </div>
                    </router-link>
                </li>
                <li class="menu hide-menu">
                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#teams" aria-controls="teams" aria-expanded="false">
                        <div class="">
                            <TeamSVG />
                            <span>{{ t('teams') }}</span>
                        </div>
                        <div>
                            <ChevronRightSVG />
                        </div>
                    </a>

                    <ul id="teams" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                        <li>
                            <router-link to="/teams/job-titles" @click="toggleMobileMenu">
                                {{ t('job_titles') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/teams/job-prefixes" @click="toggleMobileMenu">
                                {{ t('job_prefixes') }}
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/teams" @click="toggleMobileMenu">
                                {{ t('teams') }}
                            </router-link>
                        </li>

                    </ul>
                </li>

                <li class="menu hide-menu">
                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#pages" aria-controls="pages" aria-expanded="false">
                        <div class="">
                            <PageSVG />
                            <span>{{ t('pages') }}</span>
                        </div>
                        <div>
                            <ChevronRightSVG />
                        </div>
                    </a>

                    <ul id="pages" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                        <li>
                            <a class="dropdown-toggle" href="#pages-error" data-bs-parent="#pages" data-bs-toggle="collapse" role="button" aria-expanded="false">
                                Error
                                <ChevronRightSVG />
                            </a>

                            <ul id="pages-error" class="collapse list-unstyled sub-submenu">
                                <li @click="toggleMobileMenu"><a target="_blank" href="/pages/error404">404</a></li>
                                <li @click="toggleMobileMenu"><a target="_blank" href="/pages/error500">500</a></li>
                                <li @click="toggleMobileMenu"><a target="_blank" href="/pages/error503">503</a></li>
                                <li @click="toggleMobileMenu"><a target="_blank" href="/pages/maintenence">Maintanence</a></li>
                            </ul>
                        </li>

                        <li>
                            <router-link to="/pages/blank-page" @click="toggleMobileMenu">Blank Page</router-link>
                        </li>
                        <li>
                            <router-link to="/pages/sample" @click="toggleMobileMenu">Sample Page</router-link>
                        </li>
                    </ul>
                </li>

                <li class="menu hide-menu">
                    <a class="dropdown-toggle" data-bs-toggle="collapse" data-bs-target="#authentication" aria-controls="authentication" aria-expanded="false">
                        <div class="">
                            <LockSVG />
                            <span>{{ t('authentication') }}</span>
                        </div>
                        <div>
                            <ChevronRightSVG />
                        </div>
                    </a>

                    <ul id="authentication" class="collapse submenu list-unstyled" data-bs-parent="#sidebar">
                        <li @click="toggleMobileMenu"><a target="_blank" href="/auth/register-boxed">Register Boxed</a></li>
                        <li @click="toggleMobileMenu"><a target="_blank" href="/auth/login">Login Cover</a></li>
                        <li @click="toggleMobileMenu"><a target="_blank" href="/auth/register">Register Cover</a></li>
                        <li @click="toggleMobileMenu"><a target="_blank" href="/auth/lockscreen">Unlock Cover</a></li>
                    </ul>
                </li>

            </perfect-scrollbar>
        </nav>
    </div>
    <!--  END SIDEBAR  -->
</template>
<style scoped>
.hide-menu{
    display: none;
}
</style>
<script setup>
    import { onMounted, ref } from 'vue';
    import CatalogSVG from "@/components/svg/catalog.vue"
    import EventSVG from "@/components/svg/event.vue"
    import DashboardSVG from "@/components/svg/dashboard.vue"
    import PointsSVG from "@/components/svg/points.vue"
    import UsersSVG from "@/components/svg/users.vue"
    import LockSVG from "@/components/svg/lock.vue"
    import PageSVG from "@/components/svg/page.vue"
    import ChipSVG from "@/components/svg/chip.vue"
    import TeamSVG from "@/components/svg/team.vue"
    import ScreenSVG from "@/components/svg/screen.vue"
    import RedeemSVG from "@/components/svg/redeem.vue"
    import ActivityLogSVG from "@/components/svg/activity-log.vue"
    import ChevronRightSVG from "../../svg/chevron-right.vue"
    import { useStore } from 'vuex';
    import { useI18n } from 'vue-i18n';

    const {t} =useI18n()

    const store = useStore();
    const menu_collapse = ref('dashboard');

    onMounted(() => {
        const selector = document.querySelector('#sidebar a[href="' + window.location.pathname + '"]');
        if (selector) {
            const ul = selector.closest('ul.collapse');
            if (ul) {
                let ele = ul.closest('li.menu').querySelectorAll('.dropdown-toggle');
                if (ele) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            } else {
                selector.click();
            }
        }
    });

    const toggleMobileMenu = () => {
        if (window.innerWidth < 991) {
            store.commit('toggleSideBar', !store.state.is_show_sidebar);
        }
    };
</script>
